import React, { memo, Fragment } from 'react'
import { Accordion } from 'react-bootstrap'
import SidebarMenu from './SidebarMenu'
import { DashbordIcon, UsersIcon, AiReportsIcon } from '../../components/icons'

const VerticalNav = memo(() => {
    return (
        <Fragment>
            <Accordion as="ul" className="navbar-nav iq-main-menu">
                <SidebarMenu isTag="true" pathname="/" title="Dashboard">
                    <i className="icon text-gray-200">
                        <DashbordIcon />
                    </i>
                </SidebarMenu>
                <SidebarMenu isTag="true" pathname="/audiences" title="Audiences">
                    <i className="icon text-gray-200">
                        <UsersIcon />
                    </i>
                </SidebarMenu>
                <SidebarMenu isTag="true" pathname="/reports" title="AI Reports">
                    <i className="icon text-gray-200">
                        <AiReportsIcon />
                    </i>
                </SidebarMenu>
                <SidebarMenu isTag="true" pathname="/communities" title="Communities">
                    <i className="icon text-gray-200">
                        <UsersIcon />
                    </i>
                </SidebarMenu>
            </Accordion>
        </Fragment>
    )
})

VerticalNav.displayName = 'VerticalNav'
export default VerticalNav
